export class Debouncer {
  private timeout: number | undefined

  /**
   * starts a timeout before callback is called. subsequent calls resets the timer. use when needing to set dynamic time between calls
   */
  debounce(cb: () => void, timeMs?: number) {
    this.abort()
    this.timeout = window.setTimeout(() => {
      cb()
    }, timeMs)
  }

  abort() {
    clearTimeout(this.timeout)
  }
}

/**
 * returns a function with its own timer (timeout can not be changed once used)
 */
export const getDebouncer = (cb: (..._args: any) => void, timeMs?: number) => {
  let timeout: number | undefined

  return (...cbArgs: any) => {
    clearTimeout(timeout)
    timeout = window.setTimeout(() => {
      cb(...cbArgs)
    }, timeMs)
  }
}
